import { render, staticRenderFns } from "./UpdateRoleAccessModal.vue?vue&type=template&id=14133286"
import script from "./UpdateRoleAccessModal.vue?vue&type=script&lang=js"
export * from "./UpdateRoleAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports